module.exports = __webpack_public_path__ + "static/media/15-5.acc4bc3d.mp3";